import React from 'react';
import {useTranslation} from 'react-i18next';
import Icon from '../../../../../../../../../../components/icon';
import './index.css';

function NewContactsLoading({contacts}) {

	const {t} = useTranslation();

	if(contacts){
		return (
			<div className="new-contacts-loading">
				<Icon animated={'pulse'}
				      name="spinner" className="mr-2"/>{t('loadingContactText')} ... {Math.ceil(contacts.contacts.length / contacts.pages.totalRecords * 100)}%
			</div>
		);
	} else {
		return (
			<div className="new-contacts-loading">
				<Icon animated={'pulse'}
				      name="spinner" className="mr-2"/>{t('loadingContactText')} ...
			</div>
		);
	}


};



export default NewContactsLoading;
